import { render } from "./SocialIcons.vue?vue&type=template&id=eeda28bc&scoped=true"
import script from "./SocialIcons.vue?vue&type=script&lang=js"
export * from "./SocialIcons.vue?vue&type=script&lang=js"

import "./SocialIcons.vue?vue&type=style&index=0&id=eeda28bc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eeda28bc"]])

export default __exports__